export interface ILenderKeyParams {
  lenderID: string;
}

export const lenderKeys = {
  root: (params: ILenderKeyParams) => ['lender', params.lenderID] as const,
  loanRequest: (params: ILenderKeyParams) =>
    [...lenderKeys.root(params), 'loan requests'] as const,
};

export function parseLenderKey<T extends keyof typeof lenderKeys>(
  queryKey: ReturnType<(typeof lenderKeys)[T]>
) {
  const [, lenderID] = queryKey;

  return { lenderID };
}
